import EmptyState from './EmptyState'

function LockIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M8 11V8a4 4 0 0 1 8 0v3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  )
}

interface NoAccessScreenProps {
  /**
   * `no-tables` — the user has no accessible tables at all.
   * `no-table-access` — the user opened a specific table they can't read.
   * `no-column-access` — the user can access the table but none of its columns.
   * `no-admin-access` — the user cannot administer users or permissions.
   */
  variant: 'no-tables' | 'no-table-access' | 'no-column-access' | 'no-admin-access'
  message?: string
}

/**
 * Clear "you don't have access" screen for expected authorization states.
 */
export default function NoAccessScreen({ variant, message }: NoAccessScreenProps) {
  const copy =
    variant === 'no-table-access'
      ? {
          title: 'No access to this table',
          message: "You don't have permission to view this table.",
        }
      : variant === 'no-column-access'
        ? {
            title: 'No accessible fields',
            message: "You don't have permission to view any fields in this table.",
          }
        : variant === 'no-admin-access'
          ? {
              title: 'No access',
              message: message ?? "You don't have permission to access this page.",
            }
          : {
              title: 'No access',
              message: "You don't have access to any tables yet.",
            }

  return <EmptyState icon={<LockIcon />} title={copy.title} message={copy.message} />
}
